/* ============================================================
   Size Calculator – Modal logic, unit conversion, size matching
   ============================================================ */

(function () {
  'use strict';

  var LABELS = {
    bust:   { label: 'Bust',   unit: { metric: 'cm', imperial: 'in' } },
    waist:  { label: 'Waist',  unit: { metric: 'cm', imperial: 'in' } },
    hip:    { label: 'Hip',    unit: { metric: 'cm', imperial: 'in' } },
    weight: { label: 'Weight', unit: { metric: 'kg', imperial: 'lb' } }
  };

  function round(n) { return Math.round(n * 10) / 10; }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function humanize(s) { return String(s).replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
  function isNumericValue(v) { return v !== '' && v != null && isFinite(Number(v)); }

  function SizeCalculator(productId, config) {
    this.productId = String(productId);
    this.config = config;
    this.unit = 'imperial';
    this.values = {};
    this.activeTab = 'calculator';

    this.modal = document.querySelector('[data-sc-modal="' + this.productId + '"]');
    if (!this.modal) return;
    // Modo "en página" (sections/kdg-size-guide.liquid, 2026-10-14): calculador y tabla visibles a la vez,
    // sin ventana. La ficha de producto no lleva data-sc-inline y sigue igual.
    this.inline = this.modal.hasAttribute('data-sc-inline');
    this.modal.setAttribute('data-sc-active-tab', this.activeTab);
    (window.__sizeCalculators = window.__sizeCalculators || {})[this.productId] = this;

    this.fieldsEl = this.modal.querySelector('[data-sc-fields]');
    this.resultEl = this.modal.querySelector('[data-sc-result]');
    this.resultSizeEl = this.modal.querySelector('[data-sc-result-size]');
    this.errorEl = this.modal.querySelector('[data-sc-error]');

    this.recommendedSize = null;

    this.renderFields();
    this.bind();
    if (this.inline) this.renderChart();
  }

  SizeCalculator.prototype.renderFields = function () {
    var self = this;
    // Solo los inputs numéricos son campos del formulario; los categóricos (p.ej. cup_size,
    // una lista de tallas como "30B, 30C") son solo de visualización en la tabla.
    var inputs = (this.config.inputs || []).filter(function (k) { return self.isNumericKey(k); });
    var isOdd = inputs.length % 2 === 1;

    var labels = window.__sizeCalculatorLabels || {};
    this.fieldsEl.innerHTML = inputs.map(function (key, idx) {
      var meta = LABELS[key] || { label: humanize(key), unit: { metric: 'cm', imperial: 'in' } };
      var unitLabel = meta.unit[self.unit];
      var fieldLabel = labels[key] || meta.label;
      var placeholderTpl = labels.placeholder || 'Enter your measurement in {unit}...';
      var placeholder = placeholderTpl.replace('{unit}', unitLabel);
      var isLastOdd = isOdd && idx === inputs.length - 1;
      var current = self.values[key];
      var value = (current != null && !isNaN(current)) ? current : '';

      return (
        '<div class="size-calculator__field' + (isLastOdd ? ' size-calculator__field--full' : '') + '">' +
          '<label class="size-calculator__field-label">' + fieldLabel + '</label>' +
          '<input type="number" inputmode="decimal" step="0.1" min="0" ' +
            'class="size-calculator__input" ' +
            'data-sc-input="' + key + '" ' +
            'placeholder="' + placeholder + '" ' +
            'value="' + value + '">' +
        '</div>'
      );
    }).join('');

    this.fieldsEl.querySelectorAll('[data-sc-input]').forEach(function (input) {
      input.addEventListener('input', function (e) {
        var v = parseFloat(e.target.value);
        self.values[e.target.dataset.scInput] = isNaN(v) ? undefined : v;
      });
    });
  };

  SizeCalculator.prototype.bind = function () {
    var self = this;

    this.modal.querySelectorAll('[data-sc-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.close(); });
    });

    this.modal.querySelectorAll('[data-sc-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.setUnit(btn.dataset.scUnit); });
    });

    this.modal.querySelectorAll('[data-sc-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.switchTab(btn.dataset.scTab); });
    });

    var submit = this.modal.querySelector('[data-sc-calculate]');
    if (submit) submit.addEventListener('click', function () { self.calculate(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.inline && !self.modal.hasAttribute('hidden')) self.close();
    });
  };

  SizeCalculator.prototype.switchTab = function (tab) {
    this.activeTab = tab;
    this.modal.setAttribute('data-sc-active-tab', tab);

    this.modal.querySelectorAll('[data-sc-tab]').forEach(function (btn) {
      var active = btn.dataset.scTab === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
    });

    this.modal.querySelectorAll('[data-sc-panel]').forEach(function (panel) {
      if (panel.dataset.scPanel === tab) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (tab === 'chart') {
      this.renderChart();
    }
  };

  // Un input es "numérico" (medida con unidad) si todos sus valores en los ranges son números.
  // Si no (p.ej. cup_size = ["30B","30C"...]), es categórico: lista sin unidad ni conversión.
  SizeCalculator.prototype.isNumericKey = function (key) {
    this._numericCache = this._numericCache || {};
    if (key in this._numericCache) return this._numericCache[key];
    var ranges = this.config.ranges || [];
    var result = true;
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i][key];
      if (Array.isArray(range) && range.length) { result = range.every(isNumericValue); break; }
    }
    this._numericCache[key] = result;
    return result;
  };

  SizeCalculator.prototype.renderChart = function () {
    var tableEl = this.modal.querySelector('[data-sc-chart-table]');
    if (!tableEl) return;

    var ranges = this.config.ranges || [];
    var inputs = this.config.inputs || [];
    var self = this;
    var unitLabel = this.unit === 'metric' ? 'cm' : 'in';

    var labels = window.__sizeCalculatorLabels || {};
    var sizeHeader = labels.sizeHeader || 'Size';
    var thead = '<thead><tr><th>' + sizeHeader + '</th>' +
      inputs.map(function (key) {
        // Encabezado de columna editable desde el personalizador (window.__sizeCalculatorLabels);
        // fallback al label interno y, si no, al nombre humanizado de la clave.
        var label = labels[key] || (LABELS[key] && LABELS[key].label) || humanize(key);
        // Solo las columnas numéricas llevan unidad (cm/in); las categóricas (cup_size) no.
        var unitSuffix = self.isNumericKey(key) ? ' (' + unitLabel + ')' : '';
        return '<th>' + label + unitSuffix + '</th>';
      }).join('') +
      '</tr></thead>';

    var tbody = '<tbody>' + ranges.map(function (row) {
      var cells = inputs.map(function (key) {
        var range = row[key];
        if (!Array.isArray(range)) return '<td>—</td>';
        // Columna categórica (cup_size = lista de tallas): se muestra la lista completa tal cual.
        if (!self.isNumericKey(key)) return '<td>' + range.join(', ') + '</td>';
        var min = self.toChartUnit(range[0], key);
        var max = self.toChartUnit(range[1], key);
        return '<td>' + min + ' – ' + max + '</td>';
      }).join('');
      var isRecommended = self.recommendedSize && row.size === self.recommendedSize;
      return '<tr' + (isRecommended ? ' class="size-calculator__row--recommended"' : '') + '><td>' + row.size + '</td>' + cells + '</tr>';
    }).join('') + '</tbody>';

    tableEl.innerHTML = thead + tbody;
  };

  SizeCalculator.prototype.toChartUnit = function (value, key) {
    var num = Number(value);
    if (!isFinite(num)) return value;   // valor no numérico (p.ej. cup size) → mostrar literal
    var storage = this.config.unit || 'cm';

    if (key === 'weight') {
      var storageWeight = (storage === 'in') ? 'lb' : 'kg';
      if (this.unit === 'metric' && storageWeight === 'lb') return round(num / 2.20462);
      if (this.unit === 'imperial' && storageWeight === 'kg') return round(num * 2.20462);
      return round(num);
    }

    if (storage === 'in' && this.unit === 'metric') return round(num * 2.54);
    if (storage === 'cm' && this.unit === 'imperial') return round(num / 2.54);
    return round(num);
  };

  SizeCalculator.prototype.setUnit = function (unit) {
    if (this.unit === unit) return;
    var from = this.unit;
    this.unit = unit;

    var self = this;
    Object.keys(this.values).forEach(function (key) {
      var v = self.values[key];
      if (v == null || isNaN(v)) return;
      if (key === 'weight') {
        self.values[key] = (from === 'metric') ? round(v * 2.20462) : round(v / 2.20462);
      } else {
        self.values[key] = (from === 'metric') ? round(v / 2.54) : round(v * 2.54);
      }
    });

    this.modal.querySelectorAll('[data-sc-unit]').forEach(function (btn) {
      var active = btn.dataset.scUnit === unit;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
    });

    this.renderFields();
    this.hideMessages();

    if (this.activeTab === 'chart' || this.inline) {
      this.renderChart();
    }
  };

  SizeCalculator.prototype.open = function (tab) {
    // El modal nace dentro de la columna sticky de la ficha (.grid__item con position:sticky),
    // que crea su propio contexto de apilamiento: alli el z-index no compite con el header y el
    // menu terminaba tapando la X de cerrar. Al abrirlo lo movemos al <body> una sola vez.
    if (this.modal.parentElement !== document.body) {
      // Los colores (--sc-*) se definen en el contenedor .size-calculator y el modal los heredaba.
      // Fuera de el los pierde (tabla y pestaña quedaban en blanco): se copian al modal antes de moverlo.
      var contenedor = this.modal.closest('.size-calculator');
      if (contenedor) {
        var estilos = window.getComputedStyle(contenedor);
        ['--sc-primary', '--sc-text', '--sc-result', '--sc-border', '--sc-input-bg', '--sc-overlay'].forEach(function (nombre) {
          var valor = estilos.getPropertyValue(nombre);
          if (valor && valor.trim()) this.modal.style.setProperty(nombre, valor.trim());
        }, this);
      }
      document.body.appendChild(this.modal);
    }
    this.modal.removeAttribute('hidden');
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (tab && tab !== this.activeTab) {
      this.switchTab(tab);
    }
  };

  SizeCalculator.prototype.close = function () {
    this.modal.setAttribute('hidden', '');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  SizeCalculator.prototype.hideMessages = function () {
    this.errorEl.setAttribute('hidden', '');
    this.resultEl.setAttribute('hidden', '');
  };

  SizeCalculator.prototype.showError = function () {
    this.recommendedSize = null;
    this.resultEl.setAttribute('hidden', '');
    this.errorEl.removeAttribute('hidden');
    if (this.inline) this.renderChart();
  };

  SizeCalculator.prototype.toStorageUnit = function (value, key) {
    var storage = this.config.unit || 'cm';

    if (key === 'weight') {
      var storageWeight = (storage === 'in') ? 'lb' : 'kg';
      if (this.unit === 'metric' && storageWeight === 'lb') return value * 2.20462;
      if (this.unit === 'imperial' && storageWeight === 'kg') return value / 2.20462;
      return value;
    }

    if (this.unit === 'metric' && storage === 'in') return value / 2.54;
    if (this.unit === 'imperial' && storage === 'cm') return value * 2.54;
    return value;
  };

  SizeCalculator.prototype.calculate = function () {
    this.hideMessages();

    var self = this;
    // El cálculo usa solo inputs numéricos (medidas); los categóricos (cup_size) son solo de tabla.
    var inputs = (this.config.inputs || []).filter(function (k) { return self.isNumericKey(k); });
    var ranges = this.config.ranges || [];

    var hasMissing = inputs.some(function (k) {
      var v = this.values[k];
      return v == null || isNaN(v) || v <= 0;
    }, this);

    if (hasMissing || ranges.length === 0) {
      this.showError();
      return;
    }

    var converted = {};
    inputs.forEach(function (k) { converted[k] = self.toStorageUnit(self.values[k], k); });

    var bestIdx = -1;
    var outOfRange = false;

    for (var i = 0; i < inputs.length; i++) {
      var key = inputs[i];
      var foundIdx = -1;
      for (var r = 0; r < ranges.length; r++) {
        var range = ranges[r][key];
        if (!Array.isArray(range)) continue;
        if (converted[key] <= range[1]) { foundIdx = r; break; }
      }
      if (foundIdx === -1) { outOfRange = true; break; }
      if (foundIdx > bestIdx) bestIdx = foundIdx;
    }

    if (outOfRange || bestIdx < 0) {
      this.showError();
      return;
    }

    this.recommendedSize = ranges[bestIdx].size;
    this.resultSizeEl.textContent = this.recommendedSize;
    this.resultEl.removeAttribute('hidden');
    // En la página la tabla está a la vista: se repinta para resaltar la talla recomendada.
    if (this.inline) this.renderChart();
  };

  /* ---- Init ---- */
  function init() {
    if (!window.__scDelegated) {
      window.__scDelegated = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-sc-open]') : null;
        if (!btn) return;
        var inst = (window.__sizeCalculators || {})[btn.getAttribute('data-sc-open')];
        if (inst) inst.open(btn.getAttribute('data-sc-open-tab') || 'calculator');
      });
    }
    var configs = window.__sizeCalculatorConfigs || {};
    Object.keys(configs).forEach(function (productId) {
      var el = document.querySelector('[data-sc-modal="' + productId + '"]');
      if (!el || el.dataset.scReady) return;
      el.dataset.scReady = '1';
      new SizeCalculator(productId, configs[productId]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
